import _extends from "@babel/runtime-corejs3/helpers/extends";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { createElementVNode as _$ce, createTextVNode as _$ct, className as _$cn, createUnknownComponentVNode as _$cc, noop as _$no, extend as _$ex, EMPTY_OBJ as _$em, map as _$ma, createVNode as _$cv } from 'intact-vue';
import { linkEvent, Transition, TransitionGroup } from 'intact-vue';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { Input } from '../input';
import { Checkbox } from '../checkbox';
import { Button } from '../button';
import { Tree } from '../tree';
import { Icon } from '../icon';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    data = _this$get.data,
    className = _this$get.className,
    keyName = _this$get.keyName,
    labelName = _this$get.labelName,
    filterable = _this$get.filterable,
    filter = _filterInstanceProperty(_this$get),
    placeholder = _this$get.placeholder;
  var getShowedData = _filterInstanceProperty(this).getShowedData;
  var _this$transfer = this.transfer,
    enableAdd = _this$transfer.enableAdd,
    enableRemove = _this$transfer.enableRemove,
    add = _this$transfer.add,
    remove = _this$transfer.remove;
  var _this$check = this.check,
    isCheckAll = _this$check.isCheckAll,
    toggleCheckAll = _this$check.toggleCheckAll,
    onCheckboxChange = _this$check.onCheckboxChange,
    isIndeterminate = _this$check.isIndeterminate;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-transfer"] = true, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var Panel = function Panel(model) {
    var title = _this.get(model + "Title");
    var data = getShowedData(model);
    return _$ce(2, 'div', [_$ce(2, 'div', (_$blocks['header'] = function ($super) {
      return [_$ce(2, 'div', [this.get(model + "CheckedKeys.length"), _$ct(' /\n                    '), data.length], 0, _$cn(k + "-transfer-count")), _$cc(Checkbox, {
        'className': 'c-ellipsis',
        'value': isCheckAll(model),
        'indeterminate': isIndeterminate(model),
        'ev-click': toggleCheckAll.bind(null, model),
        'children': title
      })];
    }, __$blocks['header'] = function ($super, data) {
      var block = $blocks['header'];
      var callBlock = function callBlock() {
        return _$blocks['header'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['header'](_$no, model)), 0, _$cn(k + "-transfer-title")), filterable ? (_$blocks['filter'] = function ($super) {
      return _$cc(Input, {
        'placeholder': placeholder,
        'clearable': true,
        'size': 'small',
        '$blocks': function ($blocks) {
          var _$blocks = {},
            __$blocks = _$ex({}, $blocks);
          return (_$blocks['prefix'] = function ($super) {
            return _$cc(Icon, {
              'className': _$cn(k + "-icon-search"),
              'size': 'small'
            });
          }, __$blocks['prefix'] = function ($super, data) {
            var block = $blocks['prefix'];
            var callBlock = function callBlock() {
              return _$blocks['prefix'].call($this, $super, data);
            };
            return block ? block.call($this, callBlock, data) : callBlock();
          }), __$blocks;
        }.call($this, _$em),
        'ev-$model:value': function ev$modelValue($v) {
          $this.set(model + "Keywords", $v);
        },
        'value': $this.get(model + "Keywords")
      });
    }, __$blocks['filter'] = function ($super, data) {
      var block = _filterInstanceProperty($blocks);
      var callBlock = function callBlock() {
        return _filterInstanceProperty(_$blocks).call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, _filterInstanceProperty(__$blocks).call(__$blocks, _$no, model)) : undefined, _$ce(2, 'div', (_$blocks['list'] = function ($super) {
      return _$cc(TransitionGroup, {
        'name': 'k-fade',
        'children': _$ma(data, function ($value, $key) {
          var _$cn2;
          return _$ce(2, 'div', _$cc(Checkbox, {
            'name': model,
            'trueValue': $value[keyName],
            'disabled': $value.disabled,
            'ev-click': onCheckboxChange.bind(this, model, $key),
            'children': (_$blocks['label'] = function ($super) {
              return $value[labelName];
            }, __$blocks['label'] = function ($super, data) {
              var block = $blocks['label'];
              var callBlock = function callBlock() {
                return _$blocks['label'].call($this, $super, data);
              };
              return block ? block.call($this, callBlock, data) : callBlock();
            }, __$blocks['label'](_$no, [$value, $key, model])),
            'ev-$model:value': function ev$modelValue($v) {
              $this.set(model + "CheckedKeys", $v);
            },
            'value': $this.get(model + "CheckedKeys")
          }), 2, _$cn((_$cn2 = {}, _$cn2[k + "-transfer-item"] = true, _$cn2[k + "-disabled"] = $value.disabled, _$cn2)), null, $value[keyName] || $value[labelName] || $value);
        }, $this)
      });
    }, __$blocks['list'] = function ($super, data) {
      var block = $blocks['list'];
      var callBlock = function callBlock() {
        return _$blocks['list'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['list'](_$no, model)), 0, _$cn(k + "-transfer-list"))], 0, _$cn(k + "-transfer-panel"));
  };
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [Panel('left'), _$ce(2, 'div', [_$cc(Button, {
    'circle': true,
    'icon': true,
    'disabled': !enableRemove(),
    'ev-click': remove,
    'type': 'primary',
    'size': 'large',
    'children': _$cc(Icon, {
      'className': _$cn(k + "-transfer-icon " + k + "-icon-left")
    })
  }), _$cc(Button, {
    'circle': true,
    'icon': true,
    'disabled': !enableAdd(),
    'ev-click': add,
    'type': 'primary',
    'size': 'large',
    'children': _$cc(Icon, {
      'className': _$cn(k + "-transfer-icon " + k + "-icon-right")
    })
  })], 4, _$cn(k + "-transfer-arrows")), Panel('right')]);
}
;